import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Menu,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React, { useEffect, useState } from "react";
import EditRoleAccessModal from "../../Modals/editRoleAccessModal";
import ResetPasswordModal from "../../Modals/resetPasswordModal";
import {
  useDeleteUserMutation,
  useLazyGetUsersQuery,
  useUpdateUsersMutation,
} from "../../services/user";
import moment from "moment";
import { useUpdateMoodMutation } from "../../services/moods";
import { showError, showToast } from "../../constants/toasts";
import Pagination from "../../components/Panigation";
import IfCan from "../../components/IfCan";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";

const linkedUsers = [
  {
    id: "u1",
    name: "Alex Johnson",
    relation: "Partner",
    role: "partner",
    permissions: {
      goals: true,
      budgets: false,
      calendar: true,
    },
  },
  {
    id: "u2",
    name: "Emily Johnson",
    relation: "Child",
    role: "viewer",
    permissions: {
      goals: false,
      budgets: false,
      calendar: false,
    },
  },
];

const CustomerList = ({ searchTerm }: { searchTerm?: string }) => {
  const navigate = useNavigate();
  const [resetOpen, setResetOpen] = React.useState(false);
  const [editRoleOpen, setEditRoleOpen] = React.useState(false);
  const [getUser] = useLazyGetUsersQuery();
  const [deleteUser] = useDeleteUserMutation();
  const [Status, setStatus] = React.useState("default");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuRowId, setMenuRowId] = React.useState<number | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [userId, setUserId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [userUpdate] = useUpdateUsersMutation();

  // Pagination calculations
  const totalPages = Math.ceil(totalCount / 10);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getUserList = async () => {
    setIsLoading(true);
    try {
      const response = await getUser({
        length: 10,
        start: page,
        search: searchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUserList();
  }, [searchTerm, page]);

  const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";
    return moment(dateString).format("DD MMM YYYY");
  };

  const getGenderText = (gender: number | string | null) => {
    if (gender === null || gender === undefined || gender === "") return "-";
    if (typeof gender === "string") {
      if (gender === "male") return "Male";
      if (gender === "female") return "Female";
      return "Others";
    }
    return gender === 1 ? "Male" : gender === 2 ? "Female" : "Others";
  };

  // Helper function to get voice type text
  const getVoiceTypeText = (botVoice: number | null) => {
    if (botVoice === null || botVoice === undefined) return "-";
    return botVoice === 1
      ? "Calm Female"
      : botVoice === 2
      ? "Calm Male"
      : "others";
  };

  // Enum-like options for user status
  const USER_STATUS = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "suspended", label: "Suspended" },
  ] as const;

  type UserStatus = (typeof USER_STATUS)[number]["value"];

  const getUserStatusCode = (user: any): UserStatus => {
    if (user?.user_status) return user.user_status as UserStatus;
    switch (user?.profile_status) {
      case 1:
        return "active";
      case 2:
        return "suspended";
      case 0:
      default:
        return "inactive";
    }
  };

  const handleFingerprintUpdate = async (id: number, status: boolean) => {
    const body = {
      is_fingerprint_applied: status,
    };

    try {
      const response = await userUpdate({ body, id }).unwrap();
      if (response?.status === 200) {
        showToast(
          `Biometric ${!status ? "deactivated" : "activated"} successfully`
        );
        getUserList();
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  const handleStatusUpdate = async (id: number, Userstatus: UserStatus) => {
    const body = {
      user_status: Userstatus,
    };
    try {
      const response = await userUpdate({ body, id }).unwrap();
      if (response?.status === 200) {
        const actionText =
          Userstatus === "active"
            ? "activated"
            : Userstatus === "inactive"
            ? "deactivated"
            : "suspended";
        showToast(`User ${actionText} successfully`);
        getUserList();
      } else {
        // showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleDeleteUser = async (id: number) => {
    try {
      const response = await deleteUser({ id }).unwrap();
      if (response?.status === 200) {
        showToast("User deleted successfully");
        getUserList();
      } else {
        // showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Gender / DOB</TableCell>
              <TableCell>Voice / Language</TableCell>
              <TableCell>Subscription</TableCell>
              <TableCell>Linked Accounts</TableCell>
              <TableCell>Biometric</TableCell>
              <TableCell>Date Registered</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((user) => (
              <TableRow hover key={user.id}>
                <TableCell>
                  <div
                    className="user_block click_action"
                    onClick={() =>
                      navigate(`/manage-users/detail/${user.id}`, {
                        state: { user },
                      })
                    }
                  >
                    <figure>
                      <img
                        src={
                          user?.profile_picture?.media_file_url ||
                          "/static/images/user_placeholder.png"
                        }
                        alt=""
                      />
                    </figure>
                    <p>
                      <b>
                        {user.first_name && user.last_name
                          ? `${user.first_name} ${user.last_name}`
                          : user.first_name || user.last_name || "-"}
                      </b>
                      <span>{user.email || "-"}</span>
                      <span>
                        {user.country_code && user.phone_number
                          ? `${user.country_code} ${user.phone_number}`
                          : user.phone_number || "-"}
                      </span>
                    </p>
                  </div>
                </TableCell>
                <TableCell>
                  {getGenderText(user.gender)}
                  <br />
                  {formatDate(user.date_of_birth)}
                </TableCell>
                <TableCell>
                  {getVoiceTypeText(user.Bot_voice)}
                  <br />
                  {user.preferred_language || "-"}
                </TableCell>
                <TableCell>
                  {user.profile_status === 2 ? "Premium" : "Free"}
                </TableCell>
                <TableCell>
                  {user.linked_accounts_count || "0"} Accounts
                </TableCell>
                <TableCell>
                  <IfCan module="Manage Customers" action="add_edit">
                    <SwitchToggle
                      defaultChecked={user.is_fingerprint_applied}
                      onChange={(checked) =>
                        handleFingerprintUpdate(user.id as number, checked)
                      }
                    />
                  </IfCan>
                </TableCell>
                <TableCell>{formatDate(user.created_at)}</TableCell>
                <TableCell>
                  <div className="form">
                    <IfCan module="Manage Customers" action="add_edit">
                      <Select
                        fullWidth
                        value={getUserStatusCode(user)}
                        onChange={(e) =>
                          handleStatusUpdate(
                            user.id as number,
                            e.target.value as UserStatus
                          )
                        }
                      >
                        {USER_STATUS.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </IfCan>
                    <IfCan module="Manage Customers" action="view">
                      <span>
                        {
                          USER_STATUS.find(
                            (opt) => opt.value === getUserStatusCode(user)
                          )?.label
                        }
                      </span>
                    </IfCan>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <IfCan module="Manage Customers" action="add_edit">
                        <Tooltip title="Edit User" arrow>
                          <IconButton
                            onClick={() =>
                              navigate(`/manage-users/edit/${user.id}`)
                            }
                          >
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Edit"
                            />
                          </IconButton>
                        </Tooltip>
                      </IfCan>
                    </Box>
                    <Box>
                      <Tooltip title="View User Details" arrow>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-users/detail/${user.id}`, {
                              state: { user },
                            })
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box>
                      <IfCan module="Manage Customers" action="add_edit">
                        <IconButton
                          aria-controls={
                            open && menuRowId === user.id
                              ? "basic-menu"
                              : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={
                            open && menuRowId === user.id ? "true" : undefined
                          }
                          onClick={(e) => handleClick(e, user.id)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open && menuRowId === user.id}
                          onClose={handleClose}
                          MenuListProps={{ "aria-labelledby": "basic-menu" }}
                          transformOrigin={{
                            horizontal: "right",
                            vertical: "top",
                          }}
                          anchorOrigin={{
                            horizontal: "right",
                            vertical: "bottom",
                          }}
                        >
                          {/* <MenuItem
                            onClick={() => {
                              setResetOpen(true);
                              handleClose();
                            }}
                          >
                            Reset Password
                          </MenuItem> */}
                          <MenuItem
                            onClick={() => {
                              setEditRoleOpen(true);
                              handleClose();
                              setUserId(user.id);
                            }}
                          >
                            Edit Roles / Access
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              setDeleteOpen(true);
                              setUserId(user.id);
                            }}
                          >
                            Delete User
                          </MenuItem>
                        </Menu>
                      </IfCan>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        module={data}
        page={page}
        onPageChange={onPageChange}
        totalPages={totalPages}
        setPage={setPage}
        totalCount={totalCount}
      />

      {/* <IfCan module="Manage Customers" action="add_edit">
        <ResetPasswordModal
          open={resetOpen}
          onClose={() => setResetOpen(false)}
          setOpen={setResetOpen}
        />
      </IfCan> */}

      <IfCan module="Manage Customers" action="add_edit">
        <EditRoleAccessModal
          open={editRoleOpen}
          onClose={() => setEditRoleOpen(false)}
          setOpen={setEditRoleOpen}
          id={userId as number}
        />
      </IfCan>
      <IfCan module="Manage Customers" action="delete">
        <DeleteConfirmModal
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          handleDelete={() => handleDeleteUser(userId as number)}
        />
      </IfCan>
    </>
  );
};

export default CustomerList;
